import Vue from "vue";

import Grid from "@/components/child/grid/grid";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import LoadingModalComponent from "@/components/child/loadingmodal/loadingmodal";
import loadingModalComponent from "@/components/child/loadingmodal/loadingmodal.vue";
import { Component, Watch } from "@/decorators";
import MovimentacaoContaModel from "@/models/movimentacaoContaModel";
import PaginationModel from "@/models/paginationModel";
import MovimentacaoContaService from "@/services/movimentacaoContaService";

import "../crud.scss";

@Component({
    components: {
        gridComponent,
        loadingModalComponent,
    },
})
export default class MovimentacaoContaListComponent extends Vue {
    private service = new MovimentacaoContaService();
    private loadingModalComponent: LoadingModalComponent = null;
    private gridcomponent: Grid = null;

    gridFilterKey = "";
    gridSortKey = "dataPagamento";
    gridSortOrder = "desc";
    gridData: Array<MovimentacaoContaModel> = [];
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("dataPagamento", "Data", GridColumnType.Date),
            new GridColumn("descricao", "Descri\u00e7\u00e3o", GridColumnType.String),
            new GridColumn("contaCorrenteDescricao", "Conta Corrente", GridColumnType.String),
            new GridColumn("contaGerencialDescricao", "Conta Gerencial", GridColumnType.String),
            new GridColumn("valor", "Valor", GridColumnType.MoneyWithSignal),
        ];
    }

    pageIndex = 1;
    pageSize = 20;
    total = 0;

    pags = false;
    tipoDocGerar: number = null;

    private load() {
        this.loadingModalComponent.showLoading();

        this.service
            .list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
            )
            .then(response => {
                return response.json() as Promise<PaginationModel<MovimentacaoContaModel>>;
            })
            .then(data => {
                this.gridData = data.list;
                this.total = data.total;
                if (this.pags) {
                    if (this.tipoDocGerar == 0) {
                        setTimeout(() => {
                            this.gridcomponent.gerarXls();
                        }, 2000);
                    }

                    if (this.tipoDocGerar == 1) {
                        setTimeout(() => {
                            this.gridcomponent.gerarPdf();
                        }, 2000);
                    }

                    if (this.tipoDocGerar == 2) {
                        setTimeout(() => {
                            this.gridcomponent.gerarImpressao();
                        }, 2000);
                    }

                    setTimeout(() => {
                        this.pags = false;
                    }, 2000);
                }
                this.loadingModalComponent.hide();
            })
            .catch(error => {
                this.loadingModalComponent.hide();
            });
    }

    private onEditItem(model: MovimentacaoContaModel) {
        this.$router.push("/movimentacaoconta-edicao/" + model.id);
    }

    private async onRemoveItem(model: MovimentacaoContaModel) {
        const response = await this.$showExclusaoQuestion(`${this.$t("__.ts.desejaExcl")}${model.descricao}?`);

        if (response) {
            try {
                const sucesso = await this.service.delete(model.id).withLoading().resolveWithoutJSON();
                if (sucesso) {
                    this.load();
                    this.$showExclusao();
                }
            } catch {}
        }
    }

    private onCreateItem() {
        this.$router.push("/movimentacaoconta-edicao");
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.load();
    }

    private onChangeSort(sortKey: string, sortOrder: string) {
        this.gridSortKey = sortKey;
        this.gridSortOrder = sortOrder;
        this.load();
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.load();
    }

    @Watch("pags")
    private onPags() {
        this.load();
    }

    private mounted() {
        this.loadingModalComponent = this.$refs.loadingModalComponent as LoadingModalComponent;
        this.gridcomponent = this.$refs.gridcomponent as Grid;
        this.load();
    }
}
